import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { PaginacionRequest, schemaEntityListWithPagination } from 'src/types'
import { PerfilPostDTO, PerfilRequestDTO, schemaPerfilViewDTO } from './schemas'

const getEndpoint = (url = '') => `perfiles${url}`

export const HttpPerfilesABM = {
    getPerfil: (idPerfil: number) => {
        return HttpAxiosRequest.get(getEndpoint(`/${idPerfil}`))
    },

    getPerfiles: (paginacion: PaginacionRequest, filter: PerfilRequestDTO) => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(), {
            ...paginacion,
            ...filter
        }).then(res => {
            const parsed = schemaEntityListWithPagination(schemaPerfilViewDTO).safeParse(res)

            if (!parsed.success) {
                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },

    postPerfil: (perfil: PerfilPostDTO) => {
        return HttpAxiosRequest.post(getEndpoint(), perfil)
    },

    putPerfil: (idPerfil: number, perfil: PerfilPostDTO) => {
        return HttpAxiosRequest.put(getEndpoint(`/${idPerfil}`), perfil)
    },

    inactivarPerfil: (idPerfil: number) => {
        return HttpAxiosRequest.delete(getEndpoint(`/${idPerfil}`))
    },

    activarPerfil: (idPerfil: number) => {
        return HttpAxiosRequest.post(getEndpoint(`/${idPerfil}/activar`), {})
    }
}
